import React, { useState } from 'react';
import { styled } from '@mui/system';
import { Typography, TextField, Button, Alert } from '@mui/material';
import { SaveSessionCookie } from '../../logic/CookieManager';
import * as MyStyles from '../../styles/MyStyles';
import { useNavigate } from 'react-router-dom';

const LoginContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 300px;
  max-width: 300px;
  margin: 16px auto 0;
`;

const LoginButton = styled(Button)`
  background-color: ${MyStyles.Orange};
  color: #fff;

  &:hover {
    background-color: ${MyStyles.Orange};
  }
`;

const LoginPage = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState(false); // Флаг ошибки входа
    const navigate = useNavigate();
    const {setIsLoggedIn, setIsLoading } = props;

    const handleLogin = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_LOGIN_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email, password: password }),
            });

            if (response.ok) {
                const data = await response.json();
                const token = data.data.token;
                SaveSessionCookie('nplt', token);
                setIsLoading(true);
                setIsLoggedIn(true);

                navigate('/');
            } else {
                setIsLoggedIn(false);
                setLoginError(true);
                console.log('Login failed');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    return (
        <LoginContainer>
            <Typography variant="h6" component="div">
                Login Form
            </Typography>
            <TextField
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
                label="Password"
                type="password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <LoginButton variant="contained" color="primary" onClick={handleLogin}>
                Login
            </LoginButton>
            {loginError && (
                <Alert severity="error">Login failed. Please check your credentials.</Alert>
            )}
        </LoginContainer>
    );
};

export default LoginPage;
